import { message, Modal } from 'antd';
import { useEffect } from 'react'
import { useLocation } from 'react-router';
import i18n from 'i18next';

export const useScrollToTop = () => {
  const location = useLocation()
  useEffect(() => {
    window.scrollTo({ top: 0 })
  }, [location])
}

const key = 'loading'
export const loadingMessage = () => {
  message.loading(
    {
      content: i18n.t('common.loading2'),
      key,
      style: {
        marginTop: 100,
      },
    }
  );

}

export const hideMessage = () => {
  const hide = message.loading(
    {
      content: i18n.t('common.loading2'),
      key,
      style: {
        marginTop: 100,
      },
    }
  );
  hide();

}


export const successMessage = (msg) => {

  message.success({
    content: msg,
    key,
    duration: 1,
    style: {
      marginTop: 100,
    }
  })
}

export const errorMessage = (msg) => {

  message.error({

    content: msg,
    key,
    duration: 0.8,
    style: {
      marginTop: 100,
    },
  });


}

export const alertMessage = (msg) => {
  Modal.info({
    content: msg,
    okText: i18n.t('common.confirm'),
    onOk() { },
  })
}

export const base64Enc = (str) => {
  return window.btoa(encodeURIComponent(str));
}

export const base64Dec = (str) => {
  return decodeURIComponent(window.atob(str));
}

export const ConvertDate = (date) => {
  const result = date.replaceAll('-', '.');
  return result;
}

export const ConvertTime = (date) => {
  const result = date.replaceAll('-', ':');
  return result;
}

export const CoverDateDotToHypen = (date) => {
  return date.replaceAll('.', '-')
}

export const truncate = (text) => {
  if (text.length > 215) {
    return text.slice(0, 215).concat('...')
  }
  return text

}

export const getCurrentYear = () => {
  const date = new Date()
  const year = date.getFullYear()
  return year
}